interface Props {
  color?: string;
}

const TelegramIcon: React.FC<Props> = ({ color = "white" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.4852 4.22519C17.3963 5.52658 15.0119 15.2496 15.0119 15.2496C15.0119 15.2496 14.8638 15.818 14.3455 15.833C14.1677 15.833 13.9308 15.818 13.6643 15.5638C13.1163 15.1 11.8722 14.2025 10.7022 13.3798C10.6578 13.4247 10.6134 13.4696 10.5542 13.5144C10.2876 13.7538 9.88775 14.0978 9.45825 14.5167C9.29533 14.6663 9.11758 14.8308 8.93992 15.0103L8.92508 15.0253C8.82142 15.1299 8.73258 15.2048 8.6585 15.2646C8.08091 15.7433 8.02167 15.3393 8.02167 15.1299L8.33268 11.7044V11.6745L8.3475 11.6446C8.36233 11.5998 8.39192 11.5848 8.39192 11.5848C8.39192 11.5848 14.4492 6.13988 14.6121 5.5565C14.6269 5.52658 14.5824 5.49667 14.5084 5.52658C14.1085 5.66122 7.13307 10.1188 6.36296 10.6125C6.31853 10.6424 6.18524 10.6274 6.18524 10.6274L2.79378 9.50559C2.79378 9.50559 2.39392 9.34101 2.5272 8.96701C2.55682 8.89226 2.60125 8.81742 2.76416 8.71276C3.51947 8.17424 16.6558 3.40247 16.6558 3.40247C16.6558 3.40247 17.0261 3.28281 17.2483 3.3576C17.3519 3.40247 17.4112 3.44735 17.4704 3.59693C17.4852 3.65677 17.5 3.77644 17.5 3.91107C17.5 3.98586 17.4852 4.07561 17.4852 4.22519Z"
        fill={color}
      />
    </svg>
  );
};

export default TelegramIcon;
